<template>
    <div class="inline-block group transition-opacity duration-300 w-full text-center md:text-left" :class="anim ? 'anim' : 'opacity-0'">
        <div class="overflow-hidden">
            <div
                class="group-[.anim]:animate-slide-title font-custom tracking-tight pb-2 pr-1 text-primary-400 text-5xl xs:text-[3.4rem] md:text-8xl lg:text-8xl xl:text-9xl font-bold"
                style="
                    text-shadow:
                        -0.5px -1px 0px var(--color-primary-200),
                        1px 1px 0px var(--color-neutral-600);
                "
            >
                {{ content[indexContent].title }}
            </div>
        </div>
        <!-- <div class="bg-transparent h-[3px] rounded-full group-[.anim]:animate-slide-bar flex">
            <div class="size-full bg-primary group-[.anim]:animate-slide-timer" :style="styleTimer" />
        </div> -->
        <div class="overflow-hidden">
            <div class="group-[.anim]:animate-slide-desc">
                <div
                    class="font-bold text-white text-xl xs:text-2xl md:text-2xl lg:text-3xl xl:text-4xl pt-0 pl-1"
                    style="
                        text-shadow:
                            -0.5px -0.5px 0px var(--color-amber-100),
                            1px 1px 0px var(--color-neutral-600);
                    "
                >
                    {{ content[indexContent].description }}
                </div>
            </div>
        </div>
        <!-- <UButtonLocale
            :to="content[indexContent].buttonLink"
            class="group-[.anim]:animate-slide-button inline-block backdrop-blur-xl rounded-full overflow-clip mt-4"
            base-class="px-15"
            size="xl"
        >
            {{ content[indexContent].buttonText }}
        </UButtonLocale> -->
    </div>
</template>

<script setup lang="ts">
const anim = ref(false);

export type ContentSlide = {
    title: string;
    description: string;
    buttonText: string;
    buttonLink: string;
};

const props = withDefaults(
    defineProps<{
        content: ContentSlide[];
        index?: number;
        duration?: number;
    }>(),
    {
        index: 0,
        duration: 5000
    }
);

const indexContent = ref(props.index);
// const styleTimer = computed(() => ({
//     'animation-duration': `${props.duration}ms`
// }));

function startAnimation() {
    anim.value = false;
    setTimeout(() => {
        indexContent.value = props.index;
        anim.value = true;
    }, 200);
}

watch(
    () => props.index,
    () => {
        startAnimation();
    }
);

onMounted(() => {
    anim.value = true;
});
</script>
